import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import VueAxios from 'vue-axios'

Vue.config.productionTip = false
Vue.use(VueAxios, Axios)

// Axios.defaults.baseURL = 'http://47.102.201.6:9001'
Axios.defaults.baseURL = 'https://m.shuian.ahyinxun.net'
// Axios.defaults.baseURL = 'https://api.zhyunxi.cn'
Axios.defaults.withCredentials = true
Vue.prototype.$axios = Axios
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
